import { IUploadCredentials } from '../../../types/UploadCredentials'

export default function (params: IUploadCredentials, file: File) {
  const fd = new FormData()
  fd.append('key', params.key)
  fd.append('acl', params.acl)
  fd.append('policy', params.policy)
  fd.append('x-amz-algorithm', params.xAmzAlgorithm)
  fd.append('x-amz-credential', params.xAmzCredential)
  fd.append('x-amz-date', params.xAmzDate)
  fd.append('x-amz-signature', params.xAmzSignature)
  fd.append('x-amz-security-token', params.xAmzSecurityToken)
  fd.append('file', file)
  return fd
}
